// src/app/pipes/format-text.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatText',
  standalone: true
})
export class FormatTextPipe implements PipeTransform {
  /**
   * Transforms a given text by formatting URLs, tabs, and newlines.
   *
   * @param {string} value - The input text to be formatted.
   * @returns {string} - The formatted text.
   */
  transform(value: string): string {
    // Return the original value if it is falsy (e.g., null, undefined, or empty string)
    if (!value) {
      return value;
    }

    // Regular expression pattern to match URLs
    const urlPattern = /(https?:\/\/[^\s]+)/g;

    // Replace URLs with anchor tags
    let formatted = value.replace(
      urlPattern,
      '<a href="$1" target="_blank">$1</a>'
    );

    // Replace tab characters with four non-breaking spaces
    formatted = formatted.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');

    // Replace double newlines with double <br> tags
    formatted = formatted.replace(/(\r\n\r\n|\n\n|\r\r)/g, '<br><br>');

    // Replace single newlines with single <br> tags
    formatted = formatted.replace(/(\r\n|\n|\r)/g, '<br>');

    // Return the formatted text
    return formatted;
  }
}
